export default {
  email: 'email',
  emailAndPhone: 'email&phone',
  emailButNotPhone: 'email!phone',
  phoneInUsers: 'phoneInUsers',
  phoneInContacts: 'phoneInContacts',
  phone: 'phone',
};
